import React, { createContext, useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { isLoadingState } from "../../../recoil/states/default";
import axiosRc from '../../../../src/config/axios-rc'

const initialState = {
    ddlTitle: [],
    ddlYear: [],
    ddlDegree: [],
    ddlField: [],
    ddlInstitute: [],
    //profes
    ddlProLicense: [],
    ddlProDept: [],
    //capabilty
    ddlCapability: [],
    ddlCapabilityLang: [],
    ddlCapabilityLevel: [],
    // ddlRc
    ddlCertificate: [],
    ddlNationality: [],
    ddlRace: [],
    ddlReligion: [],
    ddlMaritalStatus: [],
    ddlMilitaryStatus: [],
    ddlAppProfileType: [],
    ddlRelation: [],
    ddlReference: [],
    getDDLLabel: () => { },
    getDDLId: () => { }
}

const DropdownDataContext = createContext(initialState);

const DropdownDataProvider = ({ children }) => {
    const setIsLoading = useSetRecoilState(isLoadingState)
    const [allDDL, setAllDDL] = useState(null)

    useEffect(() => {
        setIsLoading(true)
        getDropdownData()
        setIsLoading(false)
    }, [])


    const getDropdownData = async () => {
        const { data } = await axiosRc.get(`/appProfile/get_dropdown_data`);
        const ddlWf = {
            ddlTitle: [],
            ddlCapability: [],
            ddlCapabilityLang: [],
            ddlCapabilityLevel: [],
            ddlDegree: [],
            ddlField: [],
            ddlProDept: [],
            ddlProLicense: [],
            ddlInstitute: [],
        }

        if (data.ddlWf) {
            const ddl = data.ddlWf
            ddlWf.ddlTitle = setDDLValue(ddl.title, 'titleName', 'titleName')
            ddlWf.ddlCapability = setDDLValue(ddl.capability, 'capabilityName', 'capabilityName', 'id')
            ddlWf.ddlCapabilityLang = setDDLValue(ddl.capabilityLang, 'capabilityLangName', 'capabilityLangName', 'id')
            ddlWf.ddlDegree = setDDLValue(ddl.degree, 'degreeName', 'degreeName')
            ddlWf.ddlField = setDDLValue(ddl.field, 'fieldName', 'fieldName')
            ddlWf.ddlProDept = setDDLValue(ddl.proDept, 'proDeptName', 'proDeptName', 'id')
            ddlWf.ddlProLicense = setDDLValue(ddl.proLicense, 'proLicenseName', 'proLicenseName', 'id')
            ddlWf.ddlCapabilityLevel = setDDLValue(ddl.capabilityLevel, 'id', 'capabilityLevelName')
            ddlWf.ddlInstitute = setDDLValue(ddl.institute, 'institutionCode', 'institutionName')
            ddlWf.ddlInstitute = allDDLOther(ddlWf.ddlInstitute)
            ddlWf.ddlDegree = allDDLOther(ddlWf.ddlDegree)
            ddlWf.ddlField = allDDLOther(ddlWf.ddlField)
            ddlWf.ddlProDept = allDDLOther(ddlWf.ddlProDept)
        }

        const ddlRc = {
            ddlCertificate: [],
            ddlNationality: [],
            ddlRace: [],
            ddlReligion: [],
            ddlMaritalStatus: [],
            ddlMilitaryStatus: [],
            ddlAppProfileType: [],
            ddlRelation: [],
            ddlReference: []
        }

        if (data.ddlRc) {
            const ddl = data.ddlRc
            const _race = ddl.race.sort((a, b) => a.dropdownNameTh.localeCompare(b.dropdownNameTh))
            const _nationality = ddl.nationality.sort((a, b) => a.dropdownNameTh.localeCompare(b.dropdownNameTh))
            const fields = ['dropdownNameTh', 'dropdownNameTh']
            ddlRc.ddlCertificate = setDDLValue(ddl.certificate, ...fields)
            ddlRc.ddlNationality = setDDLValue(_nationality, ...fields)
            ddlRc.ddlRace = setDDLValue(_race, ...fields)
            ddlRc.ddlReligion = setDDLValue(ddl.religion, ...fields)
            ddlRc.ddlMaritalStatus = setDDLValue(ddl.maritalStatus, ...fields)
            ddlRc.ddlMilitaryStatus = setDDLValue(ddl.militaryStatus, ...fields)
            ddlRc.ddlAppProfileType = setDDLValue(ddl.appProfileType, 'dropdownCode', 'dropdownNameTh')
            ddlRc.ddlRelation = setDDLValue(ddl.relation, 'dropdownCode', 'dropdownNameTh')

            ddlRc.ddlReference = allDDLOther(ddlRc.ddlRelation, 'reference')
            // delete value = 'children' in ddlReference (ไม่เอาบุตร)
            ddlRc.ddlReference = ddlRc.ddlReference.filter(item => item.value !== 'children')
            ddlRc.ddlRelation = allDDLOther(ddlRc.ddlRelation)
            ddlRc.ddlCertificate = allDDLOther(ddlRc.ddlCertificate)
        }

        // ddlYear
        const now = new Date();
        const currentYear = now.getFullYear() + 543;
        const nextYear = currentYear + 1;

        const previous48Years = Array.from({ length: 48 }, (_, index) => {
            return {
                value: currentYear - index - 1,
                label: currentYear - index - 1
            }
        });

        const yearsArray = [
            { value: nextYear, label: nextYear },
            { value: currentYear, label: currentYear },
            ...previous48Years];

        // set ddl data to state
        setAllDDL({
            ddlTitle: ddlWf.ddlTitle,
            ddlCapability: ddlWf.ddlCapability,
            ddlCapabilityLang: ddlWf.ddlCapabilityLang,
            ddlDegree: ddlWf.ddlDegree,
            ddlField: ddlWf.ddlField,
            ddlProDept: ddlWf.ddlProDept,
            ddlInstitute: ddlWf.ddlInstitute,
            ddlProLicense: ddlWf.ddlProLicense,
            ddlYear: yearsArray,
            ddlCapabilityLevel: ddlWf.ddlCapabilityLevel,

            ddlCertificate: ddlRc.ddlCertificate,
            ddlNationality: ddlRc.ddlNationality,
            ddlRace: ddlRc.ddlRace,
            ddlReligion: ddlRc.ddlReligion,
            ddlMaritalStatus: ddlRc.ddlMaritalStatus,
            ddlMilitaryStatus: ddlRc.ddlMilitaryStatus,
            ddlAppProfileType: ddlRc.ddlAppProfileType,
            ddlRelation: ddlRc.ddlRelation,
            ddlReference: ddlRc.ddlReference
        })
        return data
    }

    const setDDLValue = (data, fieldValue, fieldLabel, fieldId) => {
        if (data && data.length > 0) {
            return data.map(item => {
                let _data = {
                    value: item[fieldValue],
                    label: item[fieldLabel],
                    isDeleted: item.isDeleted ?? false,
                    isInactive: item.isInactive ?? false
                }
                return (fieldId ? { ..._data, [fieldId]: item[fieldId] } : _data)
            })
        }
        return null
    }

    const allDDLOther = (ddlData, type) => {
        if (ddlData?.length > 0) {
            const label = type === 'reference' ? 'อื่น ๆ (เช่น อาจารย์ที่ปรึกษา, หัวหน้า, ผู้บังคับบัญชา)' : 'อื่น ๆ'
            return [
                ...ddlData,
                {
                    value: 'other',
                    label: label,
                    isDeleted: false,
                    isInactive: false
                }
            ]
        }
        return null
    }

    const getDDLLabel = (ddl, value) => {
        if (ddl && ddl.length > 0) {
            const row = ddl.filter(y => y.value === value)
            if (row && row.length > 0) {
                return row[0].label
            }
        }
        return value
    }

    const getDDLId = (ddl, value) => {
        if (ddl && ddl.length > 0) {
            const row = ddl.filter(y => y.value === value)
            if (row && row.length > 0) {
                return row[0]
            }
        }
        return value
    }

    return (
        <DropdownDataContext.Provider
            value={{
                ddlTitle: allDDL?.ddlTitle,
                ddlYear: allDDL?.ddlYear,
                ddlDegree: allDDL?.ddlDegree,
                ddlCert: allDDL?.ddlCertificate,
                ddlField: allDDL?.ddlField,
                ddlProLicense: allDDL?.ddlProLicense,
                ddlProDept: allDDL?.ddlProDept,
                ddlCapability: allDDL?.ddlCapability,
                ddlCapabilityLang: allDDL?.ddlCapabilityLang,
                ddlCapabilityLevel: allDDL?.ddlCapabilityLevel,
                ddlCertificate: allDDL?.ddlCertificate,
                ddlNationality: allDDL?.ddlNationality,
                ddlRace: allDDL?.ddlRace,
                ddlReligion: allDDL?.ddlReligion,
                ddlMaritalStatus: allDDL?.ddlMaritalStatus,
                ddlMilitaryStatus: allDDL?.ddlMilitaryStatus,
                ddlAppProfileType: allDDL?.ddlAppProfileType,
                ddlRelation: allDDL?.ddlRelation,
                ddlReference: allDDL?.ddlReference,
                ddlInstitute: allDDL?.ddlInstitute,
                getDDLLabel,
                getDDLId
            }}
        >{children}
        </DropdownDataContext.Provider>
    )
}

export { DropdownDataProvider, DropdownDataContext };